// removed by extract-text-webpack-plugin
module.exports = {"Biography":"src-components-Biography----Biography-module---Biography---3T2Vx","innerContent":"src-components-Biography----Biography-module---innerContent---2pU6q","image":"src-components-Biography----Biography-module---image---26lw3","content":"src-components-Biography----Biography-module---content---2c0aw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Biography/Biography.module.css
// module id = 352
// module chunks = 86121489336791